// Our Components
import AddingClientsTabs from 'components/Tabs/AddingClientsTabs';

function WealthBoxConsumePage() {
	return <AddingClientsTabs defaultIndex={4} />;
}

export default WealthBoxConsumePage;
